import { render } from "./ContractTrainingBlockComponent.vue?vue&type=template&id=3e0f82a8&scoped=true"
import script from "./ContractTrainingBlockComponent.vue?vue&type=script&lang=js"
export * from "./ContractTrainingBlockComponent.vue?vue&type=script&lang=js"

import "./ContractTrainingBlockComponent.vue?vue&type=style&index=0&id=3e0f82a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0f82a8"]])

export default __exports__